type FluidContainerCleanProps = {
  children: React.ReactNode;
};

const FluidContainerClean: React.FC<FluidContainerCleanProps> = ({
  children,
}) => <div className="px-0 mx-0 container-fluid">{children}</div>;

export default FluidContainerClean;
